// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"text-drawing"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M15 5L1.00002 5.00001L1 19L15 19L15 5Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M23 5L15 5.00001L15 19L23 19L23 5Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M5 9L11 9M5 13L9 13","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15.0001 5V19M1.00003 5.00001L23.0001 5L23.0001 19L1 19L1.00003 5.00001Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TextDrawingIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'text-drawing',
    ref,
    icon: element,
  },
));

TextDrawingIcon.displayName = 'TextDrawingIcon';

export default TextDrawingIcon;
